import { render } from "./OrderTestDialog.vue?vue&type=template&id=3e12c7c0&scoped=true"
import script from "./OrderTestDialog.vue?vue&type=script&lang=js"
export * from "./OrderTestDialog.vue?vue&type=script&lang=js"

import "./OrderTestDialog.vue?vue&type=style&index=0&id=3e12c7c0&lang=css"
import "./OrderTestDialog.vue?vue&type=style&index=1&id=3e12c7c0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e12c7c0"]])

export default __exports__